import { render } from "./SandboxPipelines.vue?vue&type=template&id=6b8f3a8c"
import script from "./SandboxPipelines.vue?vue&type=script&lang=js"
export * from "./SandboxPipelines.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__